import React, { useState, useEffect } from 'react';

interface LoaderProps {
  text?: string;
  styleTitle?: string;
}

const LOADING_TIPS = [
  'Анализируем черты лица...',
  'Определяем форму головы...',
  'Подбираем форму причёски...',
  'Выстраиваем тени и объём...',
  'Проработка деталей стрижки...',
  'Сохраняем естественность лица...',
  'Финальные штрихи...',
  'Почти готово...',
];

export const Loader: React.FC<LoaderProps> = ({
  text = 'AI подбирает стрижку…',
  styleTitle,
}) => {
  const [tipIndex, setTipIndex] = useState(0);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    // Меняем подсказки каждые 8 секунд (чаще, чтобы показать прогресс)
    const tipInterval = setInterval(() => {
      setTipIndex((prev) => (prev + 1) % LOADING_TIPS.length);
    }, 8000);

    // Отсчёт времени
    const timeInterval = setInterval(() => {
      setElapsedSeconds((prev) => prev + 1);
    }, 1000);

    return () => {
      clearInterval(tipInterval);
      clearInterval(timeInterval);
    };
  }, []);

  // Форматируем время
  const formatTime = (seconds: number) => {
    if (seconds < 60) return `${seconds} сек.`;
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="flex flex-col items-center justify-center py-12 space-y-6">
      <div className="loader-3d" />
      <div className="text-center space-y-2">
        <p className="text-white font-semibold text-lg">{text}</p>
        {styleTitle && (
          <p className="text-accent text-sm font-medium">
            Стиль: {styleTitle}
          </p>
        )}
        <p className="text-xs text-white/50 animate-pulse">
          {LOADING_TIPS[tipIndex]}
        </p>
        <div className="mt-4 space-y-1">
          <p className="text-[11px] text-white/60">
            ⏱ Прошло: {formatTime(elapsedSeconds)}
          </p>
          <p className="text-[10px] text-white/40">
            Это может занять до 1–2 минут. Не закрывайте приложение.
          </p>
          {elapsedSeconds > 30 && (
            <p className="text-[10px] text-sheriff-accent/70 animate-pulse">
              AI работает над максимально реалистичным результатом...
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

